import React from 'react';
import PropTypes from 'prop-types';
import TextEditorInput from './TextEditorInput';
import TextInput from './TextInput';
import EnumSelectInput from './EnumSelectInput';
import InListSelectInput from './InListSelectInput';

const TYPES = {
  TEXT_EDITOR_INPUT: 'TEXT_EDITOR_INPUT',
  SELECT_DECLINE_CODE_INPUT: 'SELECT_DECLINE_CODE',
  TEXT_INPUT: 'TEXT_INPUT',
  ENUM_SELECT_INPUT: 'ENUM_SELECT_INPUT',
  IN_LIST_INPUT: 'IN_LIST_INPUT',
};

const INPUTS = {
  [TYPES.TEXT_EDITOR_INPUT]: TextEditorInput,
  [TYPES.TEXT_INPUT]: TextInput,
  [TYPES.ENUM_SELECT_INPUT]: EnumSelectInput,
  [TYPES.IN_LIST_INPUT]: InListSelectInput,
};

const InputByType = ({ name, value, onChange, inputType, propertyType, property }) => {
  const Input = INPUTS[inputType];
  return (
    Input && <Input name={name} value={value} onChange={onChange} propertyType={propertyType} property={property} />
  );
};

InputByType.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputType: PropTypes.oneOf(Object.values(TYPES)),
  propertyType: PropTypes.string,
  property: PropTypes.string,
};

InputByType.defaultProps = {
  inputType: TYPES.TEXT_INPUT,
  propertyType: 'STRING',
  property: null,
};

export { TYPES };
export default InputByType;
